import React from "react";
import "./home.scss";
import {Col, Row} from "react-bootstrap";
import GratitudeView from "./gratitude/GratitudeView";
import PillarView from "./pillars/PillarView";
import ProgressChart from "./Progress/ProgressChart";
import PointButtons from "./points/PointButtons";

export default function Home() {
  return (
    <div className={"home"}>
      <Row>
        <Col lg={12} xl={8} xxl={8}>
          <ProgressChart />
          <div className={'d-none d-xl-block'}>
            <GratitudeView />
          </div>
        </Col>
        <Col md={12} lg={12} xl={4}>
          <PointButtons />
          <PillarView />
          <div className={'d-block d-xl-none'}>
            <GratitudeView />
          </div>
        </Col>
      </Row>
    </div>
  );
}
